import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import { ValidationError } from '../../components';

import css from './FieldBubbleButton.module.css';

const FieldBubbleButtonComponent = props => {
  const {
    rootClassName,
    className,
    id,
    label,
    input,
    meta,
    options = [],
    form,
    values = {},
    onChange,
  } = props;

  if (label && !id) {
    throw new Error('id required when a label is given');
  }
  const selectedOption = values[input.name];

  const handleOptionClick = option => {
    if (selectedOption === option) {
      form.change(input.name, '');
    } else {
      form.change(input.name, option);
    }
    if (onChange) {
      onChange();
    }
  };

  const classes = classNames(rootClassName || css.root, className);
  return (
    <div className={classes}>
      {label ? <label htmlFor={id}>{label}</label> : null}
      <div className={css.container}>
        {options.map((option, index) => {
          const isSelected = selectedOption === option;
          return (
            <p
              className={isSelected ? css.optionSelected : css.optionNotSelected}
              key={index}
              onClick={() => handleOptionClick(option)}
            >
              {option}
            </p>
          );
        })}
      </div>
      <ValidationError fieldMeta={meta} />
    </div>
  );
};

FieldBubbleButtonComponent.defaultProps = {
  rootClassName: null,
  className: null,
  id: null,
  label: null,
};

const { string, object } = PropTypes;

FieldBubbleButtonComponent.propTypes = {
  rootClassName: string,
  className: string,

  // Label is optional, but if it is given, an id is also required so
  // the label can reference the input in the `for` attribute
  id: string,
  label: string,

  // Generated by final-form's Field component
  input: object.isRequired,
  meta: object.isRequired,
};

const FieldBubbleButton = props => {
  return <Field component={FieldBubbleButtonComponent} {...props} />;
};

export default FieldBubbleButton;
